// extracted by mini-css-extract-plugin
module.exports = {"ActionMenuRes":"ActionMenuRes_ActionMenuRes__17eq3","PositionSticky":"ActionMenuRes_PositionSticky__1AV8n"};